import { cpp } from "@codemirror/lang-cpp";
import { go } from "@codemirror/lang-go";
import { html } from "@codemirror/lang-html";
import { java } from "@codemirror/lang-java";
import { javascript } from "@codemirror/lang-javascript";
import { json } from "@codemirror/lang-json";
import { python } from "@codemirror/lang-python";
import { rust } from "@codemirror/lang-rust";
import { sql } from "@codemirror/lang-sql";
import { StreamLanguage } from "@codemirror/language";
import { apl } from "@codemirror/legacy-modes/mode/apl";
import { brainfuck } from "@codemirror/legacy-modes/mode/brainfuck";
import { clojure } from "@codemirror/legacy-modes/mode/clojure";
import { cmake } from "@codemirror/legacy-modes/mode/cmake";
import { cobol } from "@codemirror/legacy-modes/mode/cobol";
import { coffeeScript } from "@codemirror/legacy-modes/mode/coffeescript";
import { commonLisp } from "@codemirror/legacy-modes/mode/commonlisp";
import { crystal } from "@codemirror/legacy-modes/mode/crystal";
import { d } from "@codemirror/legacy-modes/mode/d";
import { diff as diffLang } from "@codemirror/legacy-modes/mode/diff";
import { dockerFile } from "@codemirror/legacy-modes/mode/dockerfile";
import { dylan } from "@codemirror/legacy-modes/mode/dylan";
import { ecl } from "@codemirror/legacy-modes/mode/ecl";
import { eiffel } from "@codemirror/legacy-modes/mode/eiffel";
import { elm } from "@codemirror/legacy-modes/mode/elm";
import { erlang } from "@codemirror/legacy-modes/mode/erlang";
import { factor } from "@codemirror/legacy-modes/mode/factor";
import { forth } from "@codemirror/legacy-modes/mode/forth";
import { fortran } from "@codemirror/legacy-modes/mode/fortran";
import { gas } from "@codemirror/legacy-modes/mode/gas";
import { groovy } from "@codemirror/legacy-modes/mode/groovy";
import { haskell } from "@codemirror/legacy-modes/mode/haskell";
import { haxe } from "@codemirror/legacy-modes/mode/haxe";
import { http } from "@codemirror/legacy-modes/mode/http";
import { idl } from "@codemirror/legacy-modes/mode/idl";
import { jinja2 } from "@codemirror/legacy-modes/mode/jinja2";
import { julia } from "@codemirror/legacy-modes/mode/julia";
import { liveScript } from "@codemirror/legacy-modes/mode/livescript";
import { lua } from "@codemirror/legacy-modes/mode/lua";
import { mathematica } from "@codemirror/legacy-modes/mode/mathematica";
import { fSharp, oCaml, sml } from "@codemirror/legacy-modes/mode/mllike";
import { modelica } from "@codemirror/legacy-modes/mode/modelica";
import { mumps } from "@codemirror/legacy-modes/mode/mumps";
import { nginx } from "@codemirror/legacy-modes/mode/nginx";
import { nsis } from "@codemirror/legacy-modes/mode/nsis";
import { octave } from "@codemirror/legacy-modes/mode/octave";
import { oz } from "@codemirror/legacy-modes/mode/oz";
import { pascal } from "@codemirror/legacy-modes/mode/pascal";
import { pegjs } from "@codemirror/legacy-modes/mode/pegjs";
import { perl } from "@codemirror/legacy-modes/mode/perl";
import { powerShell } from "@codemirror/legacy-modes/mode/powershell";
import { properties } from "@codemirror/legacy-modes/mode/properties";
import { protobuf } from "@codemirror/legacy-modes/mode/protobuf";
import { pug } from "@codemirror/legacy-modes/mode/pug";
import { puppet } from "@codemirror/legacy-modes/mode/puppet";
import { q } from "@codemirror/legacy-modes/mode/q";
import { r } from "@codemirror/legacy-modes/mode/r";
import { rpmChanges } from "@codemirror/legacy-modes/mode/rpm";
import { ruby } from "@codemirror/legacy-modes/mode/ruby";
import { sas } from "@codemirror/legacy-modes/mode/sas";
import { sass } from "@codemirror/legacy-modes/mode/sass";
import { scheme } from "@codemirror/legacy-modes/mode/scheme";
import { shell } from "@codemirror/legacy-modes/mode/shell";
import { sieve } from "@codemirror/legacy-modes/mode/sieve";
import { smalltalk } from "@codemirror/legacy-modes/mode/smalltalk";
import { solr } from "@codemirror/legacy-modes/mode/solr";
import { sparql } from "@codemirror/legacy-modes/mode/sparql";
import { spreadsheet } from "@codemirror/legacy-modes/mode/spreadsheet";
import { stex } from "@codemirror/legacy-modes/mode/stex";
import { stylus } from "@codemirror/legacy-modes/mode/stylus";
import { swift } from "@codemirror/legacy-modes/mode/swift";
import { tcl } from "@codemirror/legacy-modes/mode/tcl";
import { textile } from "@codemirror/legacy-modes/mode/textile";
import { tiddlyWiki } from "@codemirror/legacy-modes/mode/tiddlywiki";
import { tiki } from "@codemirror/legacy-modes/mode/tiki";
import { toml } from "@codemirror/legacy-modes/mode/toml";
import { troff } from "@codemirror/legacy-modes/mode/troff";
import { ttcn } from "@codemirror/legacy-modes/mode/ttcn";
import { ttcnCfg } from "@codemirror/legacy-modes/mode/ttcn-cfg";
import { turtle } from "@codemirror/legacy-modes/mode/turtle";
import { vb } from "@codemirror/legacy-modes/mode/vb";
import { vbScript } from "@codemirror/legacy-modes/mode/vbscript";
import { velocity } from "@codemirror/legacy-modes/mode/velocity";
import { verilog } from "@codemirror/legacy-modes/mode/verilog";
import { vhdl } from "@codemirror/legacy-modes/mode/vhdl";
import { wast } from "@codemirror/legacy-modes/mode/wast";
import { webIDL } from "@codemirror/legacy-modes/mode/webidl";
import { xml } from "@codemirror/legacy-modes/mode/xml";
import { xQuery } from "@codemirror/legacy-modes/mode/xquery";
import { yacas } from "@codemirror/legacy-modes/mode/yacas";
import { yaml } from "@codemirror/legacy-modes/mode/yaml";
import { ez80, z80 } from "@codemirror/legacy-modes/mode/z80";

import { css } from "@codemirror/lang-css";

// Language mapping for CodeMirror extensions
const languageExtensions = {
	"plaintext": () => [],
	"text": () => [],
	"javascript": () => javascript({ jsx: true, typescript: true }),
	"js": () => javascript({ jsx: true, typescript: true }),
	"typescript": () => javascript({ jsx: true, typescript: true }),
	"ts": () => javascript({ jsx: true, typescript: true }),
	"jsx": () => javascript({ jsx: true, typescript: true }),
	"tsx": () => javascript({ jsx: true, typescript: true }),
	"cpp": () => cpp(),
	"cxx": () => cpp(),
	"c": () => cpp(),
	"cplusplus": () => cpp(),
	"css": () => css(),
	"go": () => go(),
	"golang": () => go(),
	"html": () => html(),
	"java": () => java(),
	"json": () => json(),
	"python": () => python(),
	"py": () => python(),
	"rust": () => rust(),
	"rs": () => rust(),
	"sql": () => sql(),
	"apl": () => StreamLanguage.define(apl),
	"brainfuck": () => StreamLanguage.define(brainfuck),
	"b": () => StreamLanguage.define(brainfuck),
	"bf": () => StreamLanguage.define(brainfuck),
	"clojure": () => StreamLanguage.define(clojure),
	"clj": () => StreamLanguage.define(clojure),
	"cmake": () => StreamLanguage.define(cmake),
	"cobol": () => StreamLanguage.define(cobol),
	"cob": () => StreamLanguage.define(cobol),
	"cbl": () => StreamLanguage.define(cobol),
	"ccp": () => StreamLanguage.define(cobol),
	"coffeescript": () => StreamLanguage.define(coffeeScript),
	"coffee": () => StreamLanguage.define(coffeeScript),
	"commonlisp": () => StreamLanguage.define(commonLisp),
	"lisp": () => StreamLanguage.define(commonLisp),
	"cl": () => StreamLanguage.define(commonLisp),
	"crystal": () => StreamLanguage.define(crystal),
	"cr": () => StreamLanguage.define(crystal),
	"d": () => StreamLanguage.define(d),
	"diff": () => StreamLanguage.define(diffLang),
	"patch": () => StreamLanguage.define(diffLang),
	"dockerfile": () => StreamLanguage.define(dockerFile),
	"docker": () => StreamLanguage.define(dockerFile),
	"dylan": () => StreamLanguage.define(dylan),
	"dyl": () => StreamLanguage.define(dylan),
	"ecl": () => StreamLanguage.define(ecl),
	"eiffel": () => StreamLanguage.define(eiffel),
	"e": () => StreamLanguage.define(eiffel),
	"elm": () => StreamLanguage.define(elm),
	"erlang": () => StreamLanguage.define(erlang),
	"erl": () => StreamLanguage.define(erlang),
	"es": () => StreamLanguage.define(erlang),
	"factor": () => StreamLanguage.define(factor),
	"forth": () => StreamLanguage.define(forth),
	"fth": () => StreamLanguage.define(forth),
	"4th": () => StreamLanguage.define(forth),
	"fr": () => StreamLanguage.define(forth),
	"frt": () => StreamLanguage.define(forth),
	"fs": () => StreamLanguage.define(forth),
	"fortran": () => StreamLanguage.define(fortran),
	"f": () => StreamLanguage.define(fortran),
	"f90": () => StreamLanguage.define(fortran),
	"f03": () => StreamLanguage.define(fortran),
	"f08": () => StreamLanguage.define(fortran),
	"f77": () => StreamLanguage.define(fortran),
	"f95": () => StreamLanguage.define(fortran),
	"for": () => StreamLanguage.define(fortran),
	"fpp": () => StreamLanguage.define(fortran),
	"gas": () => StreamLanguage.define(gas),
	"s": () => StreamLanguage.define(gas),
	"ms": () => StreamLanguage.define(gas),
	"groovy": () => StreamLanguage.define(groovy),
	"grt": () => StreamLanguage.define(groovy),
	"gtpl": () => StreamLanguage.define(groovy),
	"gvy": () => StreamLanguage.define(groovy),
	"haskell": () => StreamLanguage.define(haskell),
	"hs": () => StreamLanguage.define(haskell),
	"haxe": () => StreamLanguage.define(haxe),
	"hx": () => StreamLanguage.define(haxe),
	"http": () => StreamLanguage.define(http),
	"idl": () => StreamLanguage.define(idl),
	"jinja2": () => StreamLanguage.define(jinja2),
	"mustache": () => StreamLanguage.define(jinja2),
	"julia": () => StreamLanguage.define(julia),
	"jl": () => StreamLanguage.define(julia),
	"livescript": () => StreamLanguage.define(liveScript),
	"ls": () => StreamLanguage.define(liveScript),
	"lua": () => StreamLanguage.define(lua),
	"mathematica": () => StreamLanguage.define(mathematica),
	"ma": () => StreamLanguage.define(mathematica),
	"mt": () => StreamLanguage.define(mathematica),
	"nb": () => StreamLanguage.define(mathematica),
	"nbp": () => StreamLanguage.define(mathematica),
	"wl": () => StreamLanguage.define(mathematica),
	"wlt": () => StreamLanguage.define(mathematica),
	"fsharp": () => StreamLanguage.define(fSharp),
	"ocaml": () => StreamLanguage.define(oCaml),
	"ml": () => StreamLanguage.define(oCaml),
	"mli": () => StreamLanguage.define(oCaml),
	"sml": () => StreamLanguage.define(sml),
	"modelica": () => StreamLanguage.define(modelica),
	"mo": () => StreamLanguage.define(modelica),
	"mumps": () => StreamLanguage.define(mumps),
	"nginx": () => StreamLanguage.define(nginx),
	"nginxconf": () => StreamLanguage.define(nginx),
	"nsis": () => StreamLanguage.define(nsis),
	"nsi": () => StreamLanguage.define(nsis),
	"octave": () => StreamLanguage.define(octave),
	"m": () => StreamLanguage.define(octave),
	"oz": () => StreamLanguage.define(oz),
	"rb": () => StreamLanguage.define(ruby),
	"conf": () => StreamLanguage.define(nginx),
	"pascal": () => StreamLanguage.define(pascal),
	"pegjs": () => StreamLanguage.define(pegjs),
	"perl": () => StreamLanguage.define(perl),
	"powerShell": () => StreamLanguage.define(powerShell),
	"properties": () => StreamLanguage.define(properties),
	"protobuf": () => StreamLanguage.define(protobuf),
	"pug": () => StreamLanguage.define(pug),
	"puppet": () => StreamLanguage.define(puppet),
	"q": () => StreamLanguage.define(q),
	"r": () => StreamLanguage.define(r),
	"rpmChanges": () => StreamLanguage.define(rpmChanges),
	"ruby": () => StreamLanguage.define(ruby),
	"sas": () => StreamLanguage.define(sas),
	"sass": () => StreamLanguage.define(sass),
	"scheme": () => StreamLanguage.define(scheme),
	"sh": () => StreamLanguage.define(shell),
	"sieve": () => StreamLanguage.define(sieve),
	"smalltalk": () => StreamLanguage.define(smalltalk),
	"solr": () => StreamLanguage.define(solr),
	"sparql": () => StreamLanguage.define(sparql),
	"spreadsheet": () => StreamLanguage.define(spreadsheet),
	"stex": () => StreamLanguage.define(stex),
	"stylus": () => StreamLanguage.define(stylus),
	"swift": () => StreamLanguage.define(swift),
	"tcl": () => StreamLanguage.define(tcl),
	"textile": () => StreamLanguage.define(textile),
	"tiddlyWiki": () => StreamLanguage.define(tiddlyWiki),
	"tiki": () => StreamLanguage.define(tiki),
	"toml": () => StreamLanguage.define(toml),
	"troff": () => StreamLanguage.define(troff),
	"ttcn": () => StreamLanguage.define(ttcn),
	"ttcnCfg": () => StreamLanguage.define(ttcnCfg),
	"turtle": () => StreamLanguage.define(turtle),
	"vb": () => StreamLanguage.define(vb),
	"vbScript": () => StreamLanguage.define(vbScript),
	"velocity": () => StreamLanguage.define(velocity),
	"verilog": () => StreamLanguage.define(verilog),
	"vhdl": () => StreamLanguage.define(vhdl),
	"wast": () => StreamLanguage.define(wast),
	"webIDL": () => StreamLanguage.define(webIDL),
	"xml": () => StreamLanguage.define(xml),
	"xQuery": () => StreamLanguage.define(xQuery),
	"yacas": () => StreamLanguage.define(yacas),
	"yaml": () => StreamLanguage.define(yaml),
	"ez80": () => StreamLanguage.define(ez80),
	"z80": () => StreamLanguage.define(z80),
} as const;

// Get the appropriate language extension based on the language identifier
export const getLanguageExtension = (language: string | null | undefined) => {
	if (!language) {
		// Default to JavaScript if no language is specified
		return languageExtensions.javascript();
	}

	const normalizedLang = language.toLowerCase().trim();

	// Check for exact match first
	if (normalizedLang in languageExtensions) {
		return languageExtensions[normalizedLang as keyof typeof languageExtensions]();
	}

	// Check for partial matches, e.g., "CPP" matches "cpp".
	const extensionKey = Object.keys(languageExtensions).find(
		(key) => normalizedLang.includes(key) || key.includes(normalizedLang)
	);

	if (extensionKey) {
		return languageExtensions[extensionKey as keyof typeof languageExtensions]();
	}

	// Fallback to JavaScript
	return languageExtensions.javascript();
};
